import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { getStudentGrades } from '@common/api/studentGrade';

import PeriodModel from '../PeriodModel';
import StudentGrade, { IStudentGradeModel } from './StudentGrade';

const StudentGrades = types
	.compose(
		PeriodModel,
		types.model('StudentGrades', {
			data: types.map(types.optional(types.array(StudentGrade), [])),
			studentId: types.number,
			service_id: types.number,
		}),
	)
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		/**
		 * group grades by program.id for every date
		 * @returns {Record<string, Record<number, IStudentGradeModel[]>>} - data grouped by program.id
		 */
		get sortedGradesByProgram() {
			const sorted: Record<string, Record<number, IStudentGradeModel[]>> = {};

			self.data.forEach((grades: IStudentGradeModel[], date) => {
				sorted[date] = grades.reduce(
					(acc, grade) => {
						const programId = grade.program?.id || 0;
						if (!acc[programId]) acc[programId] = [];
						acc[programId].push(grade);
						return acc;
					},
					{} as Record<number, IStudentGradeModel[]>,
				);
			});

			return sorted;
		},
	}))
	.actions((self) => ({
		fetch: flow(function* (program_group_ids: number[]) {
			try {
				self.loading = true;
				const result = yield getStudentGrades(self.studentId, {
					service_id: self.service_id,
					period_start: self.period_start,
					period_end: self.period_end,
					program_group_ids,
				});
				applySnapshot(self.data, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default StudentGrades;

export interface IStudentGradesModel extends Instance<typeof StudentGrades> {}
